exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collection.with-header .collection-header.tag-editor-header {\n  display: flex;\n  flex-flow: column wrap;\n  margin: 0; }\n  @media (min-width: 600px) {\n    .collection.with-header .collection-header.tag-editor-header {\n      flex-flow: row nowrap; } }\n\nh6.header-add-category,\nh6.header-add-tag {\n  flex: 1 0 50%;\n  margin: 0 0 .5rem; }\n  @media (min-width: 600px) {\n    h6.header-add-category,\n    h6.header-add-tag {\n      margin: 0; } }\n\n@media (min-width: 600px) {\n  button.btn-add-category {\n    flex: 0 0 180px; } }\n\n@media (min-width: 600px) {\n  button.btn-add-tag {\n    flex: 0 0 130px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/TagEditor.scss
// module id = 94
// module chunks = 0